<template>
  <footer>
    Right Bar default
  </footer>
</template>
<script>
export default {
  name: "RightBarDefault",
  data() {
    return {
      publicPath: process.env.VUE_APP_IMG_BASE_URL
    };
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/style/css/generic-variables.scss";
</style>
